import Title from "antd/lib/typography/Title";
import { useEffect, useRef } from "react";
import { formatPrice, numberWithCommas } from "utils/format";


const AnimatedNumber = ({ number, isPrice } : { number: number, isPrice?: boolean }) => {
	const counterRef = useRef<HTMLDivElement>(null);
	
	useEffect(() => {
		let count = 0;
		const delay = 100 / number;
		const counterInterval = setInterval(() => {
			if (count <= number) {
				if( counterRef.current ) {
					counterRef.current.innerHTML = isPrice ? formatPrice(count) : numberWithCommas(count.toString());
					count += Math.max(Math.floor(number / 100), 1);
				}
			} else {
				if(counterRef.current) {
					counterRef.current.innerHTML = isPrice ? formatPrice(number) : numberWithCommas(number.toString());
				}
				clearInterval(counterInterval);
			}
		}, delay);
 		return () => clearInterval(counterInterval);
	}, [isPrice, number]);

	return <div>
		<Title level={3} ref={counterRef}/>
	</div>;
};

export default AnimatedNumber;